import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { AuthSequence } from "../Sequences/AuthSequence";
import { browserHistory } from "react-router";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";
import { UserSettingsInterface } from "../../Entity/Entities/Settings/User/UserSettingsInterface";
import Token from "../../Token/Token";
import Auth from "../../Auth/Auth";
import ConfirmActions from "../../Action/Actions/ConfirmActions";
import PersonFactory from "../../Entity/Factories/PersonFactory";
import UserSettingsFactory from "../../Entity/Factories/UserSettingsFactory";
import TokenActions from "../../Action/Actions/TokenActions";
import UserActions from "../../Action/Actions/UserActions";

export default function* resetPassword(action: ActionInterface): any {
  try {
    yield call(Token.set, action.payload?.token);
    const res = yield call(Auth.resetPassword, {
      resetPassword: action.payload?.password,
      resetPasswordConfirm: action.payload?.confirmPassword
    });

    // Get the fresh person data from backend.
    const res2 = yield call(Auth.getSession, res.token);
    const user: PersonInterface = PersonFactory.create(res2);
    const settings: UserSettingsInterface = UserSettingsFactory.create(res2.userSettings[0]);

    // CASA-8582
    yield put({
      type: Constants.SNACKBAR_CLEAR_MESSAGES
    });

    // Load the application.
    yield put(UserActions.auth(user, settings));
    yield put(ConfirmActions.resetPasswordSuccess(user));
    yield put(TokenActions.update(res.token));
    yield put(TokenActions.successToken());
    yield AuthSequence();
    browserHistory.push("/app/dashboard/overview");
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
    yield put(ConfirmActions.resetPasswordFailure(err));
    yield put(ConfirmActions.openPopup(err.translatedMessage, err.fields));
  }
}

export function* watchResetPassword() {
  yield takeEvery(Constants.PAGE_CONFIRM_RESET_PASSWORD_REQUEST, resetPassword);
}
